import React from "react";
import "./common.scss";
import { ReactComponent as CheckedBox } from "../../Assets/Icons/checkedBox.svg";
import { ReactComponent as UncheckedBox } from "../../Assets/Icons/uncheckedBox.svg";

const Checkbox = ({
  divClassName,
  text,
  checked,
  onChecked,
  textClass,
  UncheckedIcon,
  checkClassName,
}) => {
  return (
    <>
      <div className={divClassName}>
        {checked == true ? (
          <div>
            <CheckedBox onClick={onChecked} className={`checkbox ${checkClassName}`}/>
          </div>
        ) : UncheckedIcon ? (
          <div>
            <UncheckedIcon onClick={onChecked} className={`checkbox ${checkClassName}`} />
          </div>
        ) : (
          <div>
            <UncheckedBox onClick={onChecked} className={`checkbox ${checkClassName}`} />
          </div>
        )}
        <label className={textClass}>{text}</label>
      </div>
    </>
  );
};

export default Checkbox;
